import { useState, useEffect } from "react";

import { parseInviteMemberUrl } from "../utils/helpers";
import { getInvite } from "../services/AuthActions";

type IOrgInviteOutput = Record<string, any>;

const useInviteURLData = () => {
  const [inviteData, setInviteData] = useState<IOrgInviteOutput | null>(null);
  const [inviteError, setInviteError] = useState<Error | null>(null);
  const [inviteLoading, setInviteLoading] = useState<boolean>(false);

  // SIDE-EFFECT - Process Invite URL
  useEffect(() => {
    const processInviteURL = async () => {
      try {
        setInviteLoading(true);

        const inviteURL = new URL(location.href);
        const pathname = inviteURL.pathname.trim();

        // CHECK - Pathname
        if (pathname === "/") {
          throw new Error("processInviteURL - pathname is empty");
        }

        const parsedInviteMemberURLResult = parseInviteMemberUrl(pathname);

        // CHECK - Parsed Invite Member URL Result
        if (!parsedInviteMemberURLResult) {
          throw new Error("processInviteURL - parsedInviteMemberURLResult is null");
        }

        const getInviteResult = await getInvite(parsedInviteMemberURLResult.email, parsedInviteMemberURLResult.inviteId);

        // CHECK - Get Invite Result
        if (!getInviteResult) {
          throw new Error("processInviteURL - getInviteResult is null");
        }

        setInviteData(getInviteResult);
        setInviteLoading(false);
      } catch (err) {
        setInviteError(err);
        setInviteLoading(false);
      }
    }

    processInviteURL();
  }, []);

  return {
    inviteData,
    inviteError,
    inviteLoading
  }
}

export default useInviteURLData;
